import { render, staticRenderFns } from "./SoB2bOrder.vue?vue&type=template&id=60327fa0&"
import script from "./SoB2bOrder.vue?vue&type=script&lang=js&"
export * from "./SoB2bOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports